<template>
  <div id="contenedor-listado-contrato-firmas">
    <template
      v-if="!$vuetify.breakpoint.mobile">
      <desktop
        :listadoFirmas="listadoFirmas">
      </desktop>
    </template>
    <template
      v-else>
      <mobile
      :listadoFirmas="listadoFirmas">
      </mobile>
    </template>
  </div>
</template>

<script>
import Desktop from '@/views/administracion/contratos/contrato/firmas/listado/Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoContratoFirmas',
  props: {
    listadoFirmas: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
